/**
 * UserInfo feature key returned by the API when the authenticated user can use
 * the household tag selector and InvestorTagId scoped requests.
 */
export const TAG_SELECTOR_FEATURE_PROPERTY = 'ShowUniversalTags';

/** Key passed to useUserChoices for storing the user's default viewing tag. Role prefix is added by useUserChoices. */
export const VIEWING_TAG_DEFAULT_KEY = 'DefaultViewingTag';
